import React, { useState, useEffect } from 'react';
import GeoGebraMySolAnimation from '../components/GeoGebraMySolAnimation';
import { useParams, useLocation, useNavigate, Link } from 'react-router-dom';
import 'katex/dist/katex.min.css';
import { InlineMath } from 'react-katex';
import { VscCheck,VscRocket } from "react-icons/vsc";

const CategoryProblemMySolAnimation = ()=> {
       const {doorCategoryProIDMy}=useParams();
       const navigateto = useNavigate();
       const {categoryURL, categoryTitle, problemCode, problem, category, myAnswerList, myConstructionStep, myAnswerRaw, myPointConstruction, doorCategoryProbIDMy} = useLocation().state;
       // const [randomString1, setRandomString1] = useState();
       // const [randomString2, setRandomString2] = useState();
       // const [randomString3, setRandomString3] = useState();
       // const [randomString4, setRandomString4] = useState();
       // const [randomString5, setRandomString5] = useState();

       const splitContent = (sentence) => {
              const InlineMathRegex = /<InlineMath[^>]*>(.*?)<\/InlineMath>/g;
              const matches = sentence.matchAll(InlineMathRegex);
              let lastIndex = 0;
              const contentArray = [];
              
              for (const match of matches) {
                     const InlineMathContent = <InlineMath key={lastIndex} math={match[1]} />;
                     const restOfContent = sentence.substring(lastIndex, match.index);
                     
                     contentArray.push(restOfContent, InlineMathContent);
                     lastIndex = match.index + match[0].length;
              }
              
              if (lastIndex < sentence.length) {
                     contentArray.push(sentence.substring(lastIndex));
              }
              
              return <div>{contentArray}</div>;
       };

       function ProblemLinkC ({LinkTitle, LinkId}) {
              return(
                     <div className="subject-sidebar-4">
                            {LinkId === problemCode
                                   ? <b style ={{color:'red'}}>{LinkTitle} <VscCheck/> <VscRocket/></b>
                                   : <Link to={`/door/category/problem/`} state={{
                                                 "categoryURL": categoryURL,
                                                 "categoryTitle": categoryTitle,
                                                 "problemCode": LinkId
                                          }}>
                                                 {LinkTitle}
                                          </Link>
                            }
                     </div>
              )
       }

       function ProblemLink ({LinkTitle, LinkId}) {
              return(
                     <div className="subject-sidebar-4">
                            <Link to={`/door/category/problem/`} state={{
                                   "categoryURL": categoryURL,
                                   "categoryTitle": categoryTitle,
                                   "problemCode": LinkId
                            }}>
                                   {LinkTitle}
                            </Link>
                     </div>
              )
       }

       // useEffect(() => {
       //        const revivalData = () => {
       //               const letters = '1234567890';
       //               let randomString1l = '';
       //               let randomString2l = '';
       //               let randomString3l = '';
       //               let randomString4l = '';
       //               let randomString5l = '';
       //               for (let i = 0; i < 3; i++) {
       //                      randomString1l += letters[Math.floor(Math.random() * letters.length)];
       //               }
       //               setRandomString1(randomString1l); 
       //               for (let i = 0; i < 8; i++) {
       //                      randomString2l += letters[Math.floor(Math.random() * letters.length)];
       //               }
       //               setRandomString2(randomString2l);
       //               for (let i = 0; i < 5; i++) {
       //                      randomString3l += letters[Math.floor(Math.random() * letters.length)];
       //               }
       //               setRandomString3(randomString3l);
       //               for (let i = 0; i < 7; i++) {
       //                      randomString4l += letters[Math.floor(Math.random() * letters.length)];
       //               }
       //               setRandomString4(randomString4l);
       //               for (let i = 0; i < 6; i++) {
       //                      randomString5l += letters[Math.floor(Math.random() * letters.length)];
       //               }
       //               setRandomString5(randomString5l);
       //        };
       //        revivalData();
       // },[doorCategoryProIDMy])

       return(
              <div className="App-full-row-container" key={problem.problemCode}>
                     <div className="left-menu-box-1">
                            <h4 style={{fontWeight:"bolder", color:"orange" ,marginTop:"22px", marginBottom:"15px", marginLeft:"5px"}}>
                                   {categoryTitle}
                            </h4>
                            {
                                   category && category.map(problem => {
                                          return(
                                                 <div key={problem.problemCode}>
                                                        {problem.problemCode === problemCode
                                                               ? <ProblemLinkC LinkTitle={problem.problemTitle && splitContent(problem.problemTitle)} LinkId={problem.problemCode} /> 
                                                               : <ProblemLink LinkTitle={problem.problemTitle && splitContent(problem.problemTitle)} LinkId={problem.problemCode} />
                                                        }
                                                 </div>
                                          )
                                   })
                            }
                     </div>
                     <div className="content-box-1">
                            <div className="problem" key={myAnswerRaw.answerMark}>
                                   <div className="content-fit">
                                          <h4>{myAnswerRaw.solvingTime.substring(6,10)}년 {myAnswerRaw.solvingTime.substring(3,5)}월 {myAnswerRaw.solvingTime.substring(0,2)}일 {myAnswerRaw.solvingTime.substring(12,17)}의 풀이</h4>
                                          <GeoGebraMySolAnimation
                                                 idIn={problem.problemCode}
                                                 customToolBarIn={problem.customToolBar}
                                                 allowStyleBarIn={problem.allowStyleBar}
                                                 ggbBase64In={problem.problemContent}
                                                 myPointAnswer={myPointConstruction}
                                                 myAnswerStep={myConstructionStep}
                                                 problemType={problem.problemType}
                                                 startAnimation={myAnswerRaw.startAnimation}
                                          />
                                          <div className='horizontal-flex-container'>
                                                 {/* <button 
                                                        className='button'
                                                        onClick={() => navigateto(`/door/category/problem/`, {state: {
                                                                      "categoryURL": categoryURL,
                                                                      "categoryTitle": categoryTitle,
                                                                      "problemCode": problemCode
                                                               }})}
                                                 >
                                                        문제로 돌아가기
                                                 </button> */}
                                                 <button 
                                                        className='button'
                                                        onClick={() => navigateto(`/door/category/problem/my/${doorCategoryProbIDMy}`, {state:{
                                                               "categoryURL": categoryURL,
                                                               "categoryTitle": categoryTitle,
                                                               "problemCode": problemCode,
                                                               "problem": problem,
                                                               "category": category,
                                                               "myAnswerList": myAnswerList
                                                        }})}
                                                 >
                                                        풀이 보기
                                                 </button>
                                          </div>
                                   </div>
                                   <br/>
                            </div>
                     </div>
              </div>
       );
};

export default CategoryProblemMySolAnimation;